/**
 * Chart configuration (breakdowns, metrics) is stored inside a place's
 * `filters` object so a saved view captures it together with the filters.
 * These keys are therefore never counted as an active filter, never cleared,
 * and must be stripped before a filters object is used as an API query.
 */
export const CHART_CONFIG_FILTER_KEYS = [
  'group_by',
  'table_group_by',
  'metric',
  'metrics',
  // Manager dashboard cards
  'close_rate_group_by',
  // Retired card, but saved views still carry the key.
  'top_performers_group_by',
];
